// Instacut — default barber role presets for the onboarding + welcome
// flows. When the shop admin can't think of a role title (e.g. "Master
// barber", "Apprentice"), they can pick one of these numbered defaults
// and then edit the text field further.
//
// Options above the plan's INCLUDED barbers cap render disabled with a
// hint. For Standard: "— upgrade to Premium". For Premium (above 3):
// "— £8/mo extra (add via Billing)".

import { featuresFor, EXTRA_BARBER_PRICE_GBP } from './entitlements';

export const BARBER_ROLE_COUNT = 10;

/**
 * Build the dropdown options for a given plan/shop.
 * Uses `includedBarbers` as the enabled ceiling (paid extras must go
 * through the Barbers page purchase flow — not the onboarding dropdown).
 */
export const barberRoleOptions = (shopOrPlan) => {
  const f = featuresFor(shopOrPlan);
  const included = f.includedBarbers;
  const extrasAllowed = f.extrasAllowed;
  return Array.from({ length: BARBER_ROLE_COUNT }, (_, i) => {
    const slot = i + 1;
    const disabled = slot > included;
    let hint = '';
    if (disabled) {
      hint = extrasAllowed
        ? ` — £${EXTRA_BARBER_PRICE_GBP}/mo extra`
        : ' — upgrade to Premium';
    }
    return {
      id: `barber-${slot}`,
      slot,
      label: `Barber ${slot}`,
      hint,
      disabled,
    };
  });
};

/**
 * Resolve a preset id (e.g. `barber-3`) to the human-readable label
 * that populates the free-text role field. Returns '' for unknown ids.
 */
export const barberRoleLabel = (id) => {
  if (!id) return '';
  const m = /^barber-(\d+)$/.exec(id);
  if (!m) return '';
  const n = parseInt(m[1], 10);
  if (n < 1 || n > BARBER_ROLE_COUNT) return '';
  return `Barber ${n}`;
};
